import React from "react";

const FEATURES: Array<{ label: string; icon: React.ReactNode }> = [
  {
    label: "No Coding Needed",
    icon: (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="6" y="9" width="20" height="15" rx="3" />
        <circle cx="12" cy="16" r="1.4" fill="currentColor" />
        <circle cx="20" cy="16" r="1.4" fill="currentColor" />
        <path d="M14 20 Q16 21.5 18 20" />
        <path d="M16 5 V9" />
        <circle cx="16" cy="4" r="1.3" />
      </svg>
    ),
  },
  {
    label: "Cross-Discipline Intelligence",
    icon: (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5 10 H13 V6 a2 2 0 0 1 4 0 v4 H21 a2 2 0 0 1 0 4 H19 V16 H13 v-2 a2 2 0 0 0 -4 0 v2 H5 z" />
        <path d="M5 16 V22 a2 2 0 0 0 2 2 H15 v-2 a2 2 0 0 1 4 0 v2 H21 a2 2 0 0 0 2 -2 V18 H21 a2 2 0 0 1 0 -4 H23" />
      </svg>
    ),
  },
  {
    label: "Scalable Reflection System",
    icon: (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M16 11 a5 5 0 0 1 5 5 c0 2.5 -2 3.5 -2 5.5 H13 c0 -2 -2 -3 -2 -5.5 a5 5 0 0 1 5 -5 z" />
        <path d="M14 24 H18" />
        <path d="M16 6 V3" />
        <path d="M5 16 H2" />
        <path d="M30 16 H27" />
        <path d="M8 8 L6 6" />
        <path d="M24 8 L26 6" />
      </svg>
    ),
  },
];

const ProfEHero: React.FC = () => (
  <section className="pe-hero" aria-labelledby="prof-e-hero-title">
    <div className="pe-hero__layout">
      <div className="pe-hero__side pe-hero__side--left" aria-hidden="true">
        <img
          className="pe-hero__side-img"
          src="/images/prof-e/pose-7-reading-closed.png"
          alt=""
        />
      </div>

      <div className="pe-hero__center">
        <div className="pe-hero__head">
          <h1 id="prof-e-hero-title">Reflect Think Grow</h1>
          <p className="pe-hero__tagline">
            An AI Platform to Promote Students&rsquo; Reflective Capacity
          </p>
        </div>

        <div className="pe-hero__features" aria-label="Professor E key capabilities">
          {FEATURES.map((f) => (
            <div className="pe-hero__feature" key={f.label}>
              <span className="pe-hero__feature-icon">{f.icon}</span>
              <span className="pe-hero__feature-label">{f.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="pe-hero__side pe-hero__side--right" aria-hidden="true">
        <img
          className="pe-hero__side-img"
          src="/images/prof-e/pose-3-warm.png"
          alt=""
        />
      </div>
    </div>
  </section>
);

export default ProfEHero;
